import { StepBar } from "../demo/components/StepBar";
import { NoSolarPortfolioRegistrationPage } from "../demo/noSolar";
import { ReviewData } from "./reviewData";
import { ConfirmData } from "./steps/ConfirmData";
import { DownloadTemplate } from "./steps/DownloadTemplate";
import { UploadData } from "./steps/UploadData";

const StepBarComponent = ({ ...props }) => {
  return <StepBar stepNames={["Download empty table", "Upload data", "Confirm "]} {...props} />;
};

export const CustomPortfolioPage = () => {
  const url = "/onboarding/base/portfolio-registration/draft/";
  return (
    <NoSolarPortfolioRegistrationPage
      draftUrl={url}
      draftDataUrl={url}
      StepBarComponent={StepBarComponent}
      stepComponents={[DownloadTemplate, UploadData, ConfirmData]}
      ReviewComponent={ReviewData}
    />
  );
};
